import { render, staticRenderFns } from "./qulityGrade.vue?vue&type=template&id=714cbce6&scoped=true"
import script from "./qulityGrade.vue?vue&type=script&lang=js"
export * from "./qulityGrade.vue?vue&type=script&lang=js"
import style0 from "./qulityGrade.vue?vue&type=style&index=0&id=714cbce6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714cbce6",
  null
  
)

export default component.exports